import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i-167322659__a)" }, [
      _createElementVNode("path", {
        fill: "#6E6E6E",
        d: "M22.529 20.878c.808-.54 1.405-.984 1.44-1.008l1.241-.937-1.24-.936a23.042 23.042 0 0 0 4.695-2.823l1.241-.936-1.241-.937a32.505 32.505 0 0 0-2.319-1.581c.293-.14.562-.328.797-.55 1.44-1.441 2.318-6.114 2.552-7.519l.27-1.616-1.616.27c-1.394.234-6.078 1.112-7.518 2.552-.223.235-.41.504-.55.785a32.408 32.408 0 0 0-1.57-2.307l-.937-1.241-.937 1.241a22.987 22.987 0 0 0-2.81 4.696l-.937-1.253-.937 1.241s-.468.633-1.007 1.44L3.651 2 2 3.651 28.349 30 30 28.349l-7.471-7.471Zm-.082-4.872a10.587 10.587 0 0 1-3.385-1.405l1.429-1.43a3.679 3.679 0 0 1 1.956-.678c1.253.363 2.436.96 3.478 1.756a10.596 10.596 0 0 1-3.478 1.757Zm.035-9.486a13.455 13.455 0 0 1 4.579-1.569 13.89 13.89 0 0 1-1.57 4.579 6.57 6.57 0 0 1-3.595.597c-.14-1.23.07-2.47.598-3.595m-4.732-.445a10.592 10.592 0 0 1 1.757 3.478 3.679 3.679 0 0 1-.68 1.956l-1.428 1.428a10.369 10.369 0 0 1-1.405-3.384c.363-1.253.96-2.436 1.756-3.478ZM7.457 12.715c-.738.984-3.162 4.357-3.162 6.218 0 1.453 1.265 3.806 2.038 5.095l-4.321 4.32L3.662 30l4.322-4.321c1.288.761 3.642 2.037 5.094 2.037 1.862 0 5.223-2.424 6.219-3.161l.163-.13L7.575 12.552l-.129.164h.012Zm5.621 9.146c1.253.363 2.436.96 3.478 1.757a10.594 10.594 0 0 1-3.478 1.756 10.584 10.584 0 0 1-3.384-1.405l1.428-1.429a3.68 3.68 0 0 1 1.956-.679Zm-2.927-2.928a3.68 3.68 0 0 1-.68 1.956l-1.428 1.429a10.37 10.37 0 0 1-1.406-3.385c.363-1.253.96-2.435 1.757-3.477a10.595 10.595 0 0 1 1.757 3.477Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-167322659__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M2 2h28v28H2z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon_allergen"}) } }